<script>
	import { P } from 'flowbite-svelte';
	import Panel from '../../components/Panel.svelte';
	import AbstractIdCard from '../../components/AbstractIDCard.svelte';
	import site from '../../site';
</script>

<Panel title="Account" faIcon="user">
	<P>
		Your {site.name} account is linked to your Abstract ID. To change your account settings, navigate to Abstract ID.
	</P>
	<AbstractIdCard clickable={false} />
</Panel>
